// features/manage/manageSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTrainerTableData,
  createOrUpdateTrainer,
  changeTrainerModalState,
  fetchStudentTableData,
  fetchSubjectTableData,
} from "../features/adminAsync";

const initialState = {
  showModalTrainer: false,
  trainerId: null,
  actionType: "Register",
  TrainersearchText: "",
  loading: false,
  error: null,
  trainerTableData: [],
  trainerdetails: {},
  studentTableData: [],
  SubjectmodalOpened: false,
  Subjectmode: "New Topic",
  SubjectId: null,
  SubjectsearchText: "",
  subjectTableData: [],
  subjectDetails: {},
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    changeTrainerModalStates(state, action) {
      const { showModalTrainer, trainerId, actionType } = action.payload;
      state.showModalTrainer = showModalTrainer;
      state.trainerId = trainerId;
      state.actionType = actionType;
    },
    changeTrainerModalState(state, action) {
      const { open, id, mode, details } = action.payload;
      state.TrainermodalOpened = open;
      state.trainerId = id;
      state.Trainermode = mode;
      state.trainerdetails = details;
    },
    changeTrainerSearchText(state, action) {
      state.TrainersearchText = action.payload;
    },
    loadingState(state, action) {
      state.loading = action.payload;
    },
    changeStudentTableLoadingStatus(state, action) {
      const { loading, data } = action.payload;
      state.studentTableLoadingStatus = loading;
      state.studentTableData = data;
    },
    changeSubjectModalState(state, action) {
      const { open, id, mode, } = action.payload;
      state.SubjectmodalOpened = open;
      state.SubjectId = id;
      state.Subjectmode = mode;
    },
    changeSubjectSearchText(state, action) {
      state.SubjectsearchText = action.payload;
    },
    changeSubjectTableLoadingStatus(state, action) {
      const { loading, data } = action.payload;
      state.SubjectTableLoading = loading;
      state.subjectTableData = data;
    },
  },
  extraReducers: (builder) => {
    builder
      //FetchTainerData
      .addCase(fetchTrainerTableData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainerTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerTableData = action.payload;
      })
      .addCase(fetchTrainerTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load trainer data";
      })
      // changeTrainerModalState
      .addCase(changeTrainerModalState.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeTrainerModalState.fulfilled, (state, action) => {
        const { showModal, trainerId, actionType, formData } = action.payload;
        state.showModalTrainer = showModal;
        state.trainerId = trainerId;
        state.actionType = actionType;
        state.trainerdetails = formData;
        state.loading = false;
      })
      .addCase(changeTrainerModalState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to change trainer modal state";
      })

      // createOrUpdateTrainer
      .addCase(createOrUpdateTrainer.pending, (state) => {
        state.loading = true;
      })
      .addCase(createOrUpdateTrainer.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createOrUpdateTrainer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create a new Teacher";
      })

      //Student Table Data
       .addCase(fetchStudentTableData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.studentTableData = action.payload;
      })
      .addCase(fetchStudentTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load trainer data";
      })

       //Subject Table Data
       .addCase(fetchSubjectTableData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubjectTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.subjectTableData = action.payload;
      })
      .addCase(fetchSubjectTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load trainer data";
      })
  },
});

export const {
  changeTrainerModalStates,
  changeTrainerSearchText,
  changeTrainerTableData,
  loadingState,
  changeStudentTableLoadingStatus,
  changeSubjectModalState,
  changeSubjectSearchText,
  changeSubjectTableLoadingStatus
} = adminSlice.actions;

export default adminSlice.reducer;
